

<ion-content [fullscreen]="true">
  @if (!workinprogress) {
    <div style="display: flex; width: 100%; height: 90%; padding: 32px; align-items: center; justify-content: center; flex-direction: column;">
      <img style="width: 90px;" src="../../assets/icon/icon.png" />
      <h3 style="text-align: center; margin-top: 24px;">Aggiornamento necessario</h3>
      <p style="text-align: center;">Per continuare ad utilizzare Tempo devi aggiornare la tua app</p>
      
      <ion-button *ngIf="platform=='ios'" href="https://apps.apple.com/app/id1627767717" style="margin-top: 16px;">
        <ion-icon slot="start" name="logo-apple"></ion-icon>
        <ion-label>AGGIORNA L'APP</ion-label>
      </ion-button>
      <ion-button *ngIf="platform=='android'" href="https://play.google.com/store/apps/details?id=com.vivendo.tempo" style="margin-top: 16px;">
        <ion-icon slot="start" name="logo-google-playstore"></ion-icon>
        <ion-label>AGGIORNA L'APP</ion-label>
      </ion-button>
    </div>
  }
  

  @if (workinprogress) {
    <div style="display: flex; width: 100%; height: 90%; padding: 32px; align-items: center; justify-content: center; flex-direction: column;">
      <img style="width: 90px;" src="../../assets/icon/icon.png" />
  
  
      <h3 style="text-align: center; margin-top: 24px;">App in manutenzione</h3>
      @if (message) {
        <p style="text-align: center;">{{message}}</p>
      }
      
      
      <!-- <ion-button (click)="exitApp()" style="margin-top: 24px;">
        <ion-label>Chiudi</ion-label>
      </ion-button> -->
      
    </div>
  }
  
</ion-content>
